module.exports = __webpack_public_path__ + "img/picture_viptk04n.b27bedee.png";